module.exports = __webpack_public_path__ + "img/head_finance_2.51e14757.png";